import { Box, Stack } from "@mui/material";
import logo from "../images/pdlogo.png";
import gridImage from "../images/grid-01.svg";

export default function Grid({ text, circles, luma, grid, gridSize, width = 1920, height = 1080 }) {
   // Base font sizes at 1920px canvas width (2x scale)
   // These scale proportionally with Output resolution to maintain consistent relative size
   const baseFontSizes = {
      large: 64,    // 32 * 2
      medium: 48,  // 24 * 2
      small: 32,   // 16 * 2
      xsmall: 16   // 8 * 2
   };
   
   // Scale fonts with Output resolution to maintain consistent relative size
   // ScaleToWidth will scale everything uniformly in preview, maintaining relative sizes
   const baseWidth = 1920;
   const fontScale = width / baseWidth;
   
   // Calculate border width - scales proportionally with Output resolution
   // At 1920px: 1px, At 3840px: 2px
   const borderWidth = (width / baseWidth) * 1;
   
   
   return (
      <>
         {text && (
            <>
               <Box
                  sx={{
                     fontSize: `${baseFontSizes.large * fontScale}px`, // Scales with Output resolution
                     top: "20%",
                     left: "50%",
                     position: "absolute",
                     zIndex: 1500,
                     color: "#fff",
                     textAlign: "center",
                     transform: "translateX(-50%) translateY(-50%)",
                  }}
               >
                  ABCDEFGHIJKLMNOPQRSTUVWXYZ
                  <br />
                  abcdefghijklmnopqrstuvwxyz
                  <br />
                  1234567890
               </Box>
               <Box
                  sx={{
                     fontSize: `${baseFontSizes.medium * fontScale}px`,
                     top: "50%",
                     left: "50%",
                     position: "absolute",
                     zIndex: 1500,
                     color: "#fff",
                     textAlign: "center",
                     transform: "translateX(-50%) translateY(-50%)",
                  }}
               >
                  ABCDEFGHIJKLMNOPQRSTUVWXYZ
                  <br />
                  abcdefghijklmnopqrstuvwxyz
                  <br />
                  1234567890
               </Box>
               <Box
                  sx={{
                     fontSize: `${baseFontSizes.small * fontScale}px`,
                     top: "73%",
                     left: "50%",
                     position: "absolute",
                     zIndex: 1500,
                     color: "#fff",
                     textAlign: "center",
                     transform: "translateX(-50%) translateY(-50%)",
                  }}
               >
                  ABCDEFGHIJKLMNOPQRSTUVWXYZ
                  <br />
                  abcdefghijklmnopqrstuvwxyz
                  <br />
                  1234567890
               </Box>
               <Box
                  sx={{
                     fontSize: `${baseFontSizes.xsmall * fontScale}px`,
                     top: "90%",
                     left: "50%",
                     position: "absolute",
                     zIndex: 1500,
                     color: "#fff",
                     textAlign: "center",
                     transform: "translateX(-50%) translateY(-50%)",
                  }}
               >
                  ABCDEFGHIJKLMNOPQRSTUVWXYZ
                  <br />
                  abcdefghijklmnopqrstuvwxyz
                  <br />
                  1234567890
               </Box>
            </>
         )}
         {circles && (
            <>
               <Box
                  sx={{
                     top: "50%",
                     left: "50%",
                     width: "41.67%", // ~800px at 1920px = 41.67%
                     aspectRatio: "1/1",
                     border: `${borderWidth}px solid #fff`,
                     position: "absolute",
                     zIndex: 1200,
                     borderRadius: "50%",
                     transform: "translateX(-50%) translateY(-50%)",
                  }}
               />
               <Box
                  sx={{
                     top: "0.57%", // ~11px at 1920px
                     left: "0.57%",
                     width: "15.625%", // ~300px at 1920px
                     aspectRatio: "1/1",
                     border: `${borderWidth}px solid #fff`,
                     position: "absolute",
                     zIndex: 1200,
                     borderRadius: "50%",
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                  }}
               >
                  <img src={logo} style={{ width: "66.67%", height: "auto", maxWidth: "100%" }} />
               </Box>
               <Box
                  sx={{
                     top: "0.57%",
                     right: "0.57%",
                     width: "15.625%",
                     aspectRatio: "1/1",
                     border: `${borderWidth}px solid #fff`,
                     position: "absolute",
                     zIndex: 1200,
                     borderRadius: "50%",
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                  }}
               >
                  <img src={logo} style={{ width: "66.67%", height: "auto", maxWidth: "100%" }} />
               </Box>
               <Box
                  sx={{
                     bottom: "0.57%",
                     left: "0.57%",
                     width: "15.625%",
                     aspectRatio: "1/1",
                     border: `${borderWidth}px solid #fff`,
                     position: "absolute",
                     zIndex: 1200,
                     borderRadius: "50%",
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                  }}
               >
                  <img src={logo} style={{ width: "66.67%", height: "auto", maxWidth: "100%" }} />
               </Box>
               <Box
                  sx={{
                     bottom: "0.57%",
                     right: "0.57%",
                     width: "15.625%",
                     aspectRatio: "1/1",
                     border: `${borderWidth}px solid #fff`,
                     position: "absolute",
                     zIndex: 1200,
                     borderRadius: "50%",
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                  }}
               >
                  <img src={logo} style={{ width: "66.67%", height: "auto", maxWidth: "100%" }} />
               </Box>
            </>
         )}

         {luma &&
         <>
         <Stack width="100%" height="100%" direction="row" alignItems="center" justifyContent="stretch" position="absolute" zIndex={1}>
            {[...Array(11)].map((_, i) => (
               <Box
                  key={i}
                  sx={{
                     width: "10%",
                     height: "100%",
                     backgroundColor: `rgb(${i * 25.5}, ${i * 25.5}, ${i * 25.5})`,
                  }}
               />
            ))}
         </Stack>
         <Stack width="100%" height="50%" direction="row-reverse" alignItems="center" justifyContent="stretch" position="absolute" zIndex={1}>
            {[...Array(11)].map((_, i) => (
               <Box
                  key={i}
                  sx={{
                     width: "10%",
                     height: "100%",
                     backgroundColor: `rgb(${i * 25.5}, ${i * 25.5}, ${i * 25.5})`,
                  }}
               />
            ))}
         </Stack>
         </>
         }

         <Box
            sx={{
               width: "100%",
               height: "100%",
               border: `${borderWidth}px solid #f00`,
               position: "absolute",
               zIndex: 1200,
            }}
         />
         <Box
            sx={{
               width: "0.156%", // ~3px at 1920px
               height: "100%",
               border: `${borderWidth}px solid #f00`,
               position: "absolute",
               left: "50%",
               transform: "translateX(-50%)",
               zIndex: 1000,
            }}
         />
         <Box
            sx={{
               height: "0.278%", // ~3px at 1080px
               width: "100%",
               border: `${borderWidth}px solid #f00`,
               position: "absolute",
               top: "50%",
               transform: "translateY(-50%)",
               zIndex: 1000,
            }}
         />
         <Box
            sx={{
               height: "100%",
               width: "54%",
               border: `${borderWidth}px dashed yellow`,
               position: "absolute",
               left: "50%",
               transform: "translateX(-50%)",
               zIndex: 1000,
            }}
         />

         {grid && (
         <Box
            sx={{
               width: "100%",
               height: "100%",
               backgroundImage: `url(${gridImage})`,
               backgroundSize: `${gridSize * 100}% ${gridSize * 100}%`,
               backgroundRepeat: "no-repeat",
               backgroundPosition: "center center",
               position: "absolute",
               top: 0,
               left: 0,
            }}
         />
         )}
      </>
   );
}
